module.exports = __webpack_public_path__ + "dist/img/functions.ee6fdfb1.jpg";